import * as React from "react";
import { observer } from "mobx-react";
import { formatCnpj } from "../../utils";
import { observable } from "mobx";
import { AppStore } from "../../stores/AppStore";
import { ClassificacaoStore } from "../../stores/classificacao/ClassificacaoStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { Alignment, Button, FormGroup, Tab, Tabs } from "@blueprintjs/core";
import { IEmpresa } from "../../model";
import { ClassificacaoSummary } from "./ClassificacaoSummary";
import ClassificacaoDetail from "./ClassificacaoDetail";
import moment from "moment";
import { MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import Classificacoes from "./Classificacoes";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";

var debounce = require('lodash.debounce');

@observer
export default class ClassificacaoPage extends React.Component<any, {}> {
  obs = observable({
    selectedPeriod: [] as any,
    selected_tab: "class",
    fetchOptions: {} as any
  })

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Classificação")

    this.obs.fetchOptions = debounce(this.handleBuscar.bind(this), 1000);

  }

  componentDidMount() {
    ClassificacaoStore.handldeItensProcessando();
  }

  handleView = async (notaId: any) => {
    ClassificacaoStore.obs.chave = notaId

    await ClassificacaoStore.query(ClassificacaoStore.obs.selectedEmpresa, [ClassificacaoStore.obs.date_start, ClassificacaoStore.obs.date_end], "", 1, notaId)
    ClassificacaoStore.obs.textFilter = ""
    ClassificacaoStore.obs.selectedTab = "details";
  };

  handleSelectTab(tabId: string) {
    ClassificacaoStore.obs.selectedTab = tabId;
  }

  handleDateSolicitacaoChange = (val: any) => {

    const selectedStartDate = moment(val[0]);

    let selectedEndDate = val[1] ? moment(val[1]) : null;

    if (selectedStartDate.date() === 1) {

      selectedEndDate = selectedEndDate || selectedStartDate.clone().endOf('month');

      this.obs.selectedPeriod = [selectedStartDate.toDate(), selectedEndDate.toDate()];

    } else {

      this.obs.selectedPeriod = [selectedStartDate.toDate(), selectedEndDate ? selectedEndDate.toDate() : null];

    }

    ClassificacaoStore.obs.date_start = selectedStartDate.format("YYYY-MM-DD");
    ClassificacaoStore.obs.date_end = selectedEndDate ? selectedEndDate.format("YYYY-MM-DD") : null;

    this.obs.fetchOptions()

  };

  async handleBuscar() {

    if (!ClassificacaoStore.obs.selectedEmpresa.cnpj) {
      return
    }

    if (!ClassificacaoStore.obs.date_start || ClassificacaoStore.obs.date_start == "Data inválida") {
      return
    }

    if (!ClassificacaoStore.obs.date_end || ClassificacaoStore.obs.date_end == "Data inválida") {
      return
    }

    await ClassificacaoStore.summary(ClassificacaoStore.obs.selectedEmpresa, [ClassificacaoStore.obs.date_start, ClassificacaoStore.obs.date_end])

    ClassificacaoStore.obs.selectedTab = "summary";
    ClassificacaoStore.obs.textFilter = ""

  }

  async handldeChargeTab(tabId) {

    if (String(tabId) == "tarefas") {
      await ClassificacaoStore.handleConsultaTodas(1, 15);
    }

    this.obs.selected_tab = String(tabId);

  }

  render() {

    let empresaText = ClassificacaoStore.obs.selectedEmpresa.cnpj != ""
      ? `${ClassificacaoStore.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(ClassificacaoStore.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    return (
      <>

        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={this.obs.selected_tab}
          onChange={(tabId) => this.handldeChargeTab(tabId)}
          data-tut="resumo"
        >
          <Tab
            id="class"
            title="Classificar"
            panel={<>

              <MDBRow>
                <MDBCol md="4">
                  <FormGroup className="empresaSelect" label="Empresa">
                    <EmpresaSelect
                      items={EmpresaStore.sortedEmpresas}
                      itemRenderer={renderEmpresa}
                      itemPredicate={filterEmpresa}
                      onItemSelect={(e: IEmpresa) => {ClassificacaoStore.obs.selectedEmpresa = e; this.handleBuscar();}}
                      inputProps={{ placeholder: "Filtrar uma empresa" }}
                    >
                      <Button
                        text={empresaText}
                        rightIcon="double-caret-vertical"
                        alignText={Alignment.LEFT}
                      />
                    </EmpresaSelect>
                  </FormGroup>
                </MDBCol>

                <MDBCol md="3" className="inputsPeriodoCalculos">
                  <FormGroup label="Período">
                    <DateRangePicker30
                      onChange={this.handleDateSolicitacaoChange}
                      value={this.obs.selectedPeriod}
                      disabled={false}
                    />
                  </FormGroup>
                </MDBCol>

                <MDBCol md="2" className="buttonConsultaCalculo">
                  <Button
                    text="Buscar"
                    intent="primary"
                    icon="tick"
                    onClick={() => this.handleBuscar()}
                    loading={ClassificacaoStore.obs.loading}
                  />
                </MDBCol>

              </MDBRow>

              <Tabs
                id="tabs"
                className={"tabsCalculos"}
                selectedTabId={ClassificacaoStore.obs.selectedTab}
                onChange={(tabId) => this.handleSelectTab(String(tabId))}
                data-tut="resumo"
              >
                <Tab
                  id="summary"
                  title="Notas"
                  panel={<ClassificacaoSummary onView={this.handleView} />}
                />

                <Tab
                  id="details"
                  title="Detalhamento"
                  panel={<ClassificacaoDetail />}
                  disabled
                />
              </Tabs>

            </>}
          />

          <Tab
            id="tarefas"
            title="Classificações Realizadas"
            panel={<Classificacoes />}
          />

        </Tabs>
      </>
    )
  }

}